export interface BankCard {
  id: string; // Guid
  cardMask: string;
  bankName: string;
  bankShortName: string;
  cardType: string;
  isActive: boolean;
  canRemove: boolean;
  expireDate: Date;
  cardState: BankCardState;
  bankMfiId: string;
  isNew: boolean;
}

export const BankCardState = {
  Active: 0,
  DisabledByUser: 1,
  DisabledBySystem: 2,
  RecurrenceExpired: 3,
  RecurrenceError: 4,
  MoneySendError: 5,
  DisabledByAdmin: 6,
  EnrollmentFailed: 7,
} as const;

export interface BankCardAuthForm {
  actionEndpoint: string;
  formFields: { [key: string]: string };
}

export type BankCardState = (typeof BankCardState)[keyof typeof BankCardState];

export const AddBankCardResultTypes = {
  Success: 'success',
  Processing: 'processing',
  Expiration: 'expiration',
  WrongData: 'wrong-data',
  InsufficientFunds: 'funds',
  Restricted: 'restricted',
  Card3dSecureError: '3ds',
  Auth: 'auth',
  UsedOnAnotherAccount: 'used',
} as const;

export type AddBankCardResultTypes =
  (typeof AddBankCardResultTypes)[keyof typeof AddBankCardResultTypes];

// Passed to the screen that asked for a card, from the partner's return
// address.
export interface BankCardResultState {
  bankCardResult?: string;
}
